import React, { useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import TableHeader from './FournisseurTableHeader';
// import classNames from 'classnames';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Dropdown } from 'react-bootstrap';
// import CardDropdown from 'components/common/CardDropdown';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaRegFileLines } from 'react-icons/fa6';
import { RiFileEditLine } from 'react-icons/ri';
import { FiArchive } from 'react-icons/fi';
import { getFournisseurs } from 'data/fournisseus';
import { useNavigate } from 'react-router-dom';

const columns = [
  {
    accessorKey: 'id',
    header: 'RÉFÉRENCE',
    meta: {
      headerProps: { className: 'pe-1 white-space-nowrap text-900' },
      cellProps: { className: 'font-sans-serif white-space-nowrap' }
    }
  },
  {
    accessorKey: 'nom',
    header: 'NOM DU RESPONSABLE',
    meta: {
      headerProps: { className: 'text-start text-900 ' },
      cellProps: {
        className: ' text-start w-5 fw-semibold'
      }
    },
    //"xs" | "lg" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x"
    cell: ({ row: { original } }) => {
      const { nomResponsable, emailResponsable } = original;

      return (
        <div className="d-flex">
          <div className="ms-3">
            <h6
              className="text-start fw-bold text-black"
              style={{ marginBottom: 0 }}
            >
              {nomResponsable ? nomResponsable : '--'}
            </h6>

            <p className="text-start" style={{ marginBottom: 0 }}>
              {emailResponsable ? emailResponsable : '--'}
            </p>
          </div>
        </div>
      );
    }
  },
  {
    accessorKey: 'Raison Sociale',
    header: 'RAISON SOCIALE / MATRICULE FISCALE',
    meta: {
      headerProps: { className: 'text-start text-900 ' },
      cellProps: {
        className: 'text-start text-primary fw-semibold'
      }
    },
    cell: ({ row: { original } }) => {
      const { societe, identificationFiscale } = original;

      return (
        <div className="d-flex">
          <div>
            <h6
              className="text-start fw-bold text-black"
              style={{ marginBottom: 0 }}
            >
              {societe ? societe : '--'}
            </h6>

            <p className="text-start" style={{ marginBottom: 0 }}>
              {identificationFiscale ? identificationFiscale : '--'}
            </p>
          </div>
        </div>
      );
    }
  },
  {
    accessorKey: 'CA',
    header: "CHIFFRES D'AFFAIRES",
    meta: {
      headerProps: { className: 'text-start text-900 ' },
      cellProps: {
        className: 'text-center w-5 text-primary fw-semibold'
      }
    },
    cell: ({ row: { original } }) => {
      const { ca } = original;
      return (
        <div className="d-flex align-items-center justify-content-center">
          <p className="mb-0 fs-9 fw-semibold">{`${ca || '0,000'}`}</p>
          <sup className="text-black">TND</sup>
        </div>
      );
    }
  },
  {
    accessorKey: 'ACTIONS',
    header: 'ACTIONS',
    meta: {
      headerProps: {
        className: 'text-center text-900'
      },
      cellProps: {
        className: 'fs-9'
      }
    },
    cell: ({ row: { original } }) => {
      // const [isHovered, setIsHovered] = useState(false);
      const { id } = original;
      const navigate = useNavigate();
      return (
        <div className="text-end">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: 'fixed' }} // Apply the custom style
                className="custom-tooltip" // Apply the custom class
                id="overlay-trigger-example"
              >
                Consulter Produit
              </Tooltip>
            }
          >
            <Button
              variant="link"
              className="p-0"
              onClick={() => {
                navigate(`/dashboard/produitsServices/${id}`);
              }}
            >
              <FaRegFileLines />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: 'fixed' }} // Apply the custom style
                className="custom-tooltip" // Apply the custom class
                id="overlay-trigger-example"
              >
                Editer Produit
              </Tooltip>
            }
          >
            <Button variant="link" className="p-0 mx-3">
              <RiFileEditLine />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: 'fixed' }} // Apply the custom style
                className="custom-tooltip" // Apply the custom class
                id="overlay-trigger-example"
              >
                Archiver Produit
              </Tooltip>
            }
          >
            <Button variant="link" className="p-0">
              <FiArchive />
            </Button>
          </OverlayTrigger>
        </div>
      );
    }
  }
];

const ProduitsTable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    // setData([
    //   {
    //     id: '01',
    //     societe: 'societe1',
    //     adresse: 'Adresse 111 1',
    //     telephones: '1112222, 5556666',
    //     identificationFiscale: '123456789',
    //     siteWeb: 'www.societe1.com',
    //     Civilite: '1',
    //     nomResponsable: 'Responsable societe 1',
    //     emailResponsable: 'email1@gmail.com'
    //   }
    // ]);
    const fetchFournisseurs = async () => {
      try {
        const response = await getFournisseurs();
        console.log('produitsFetched : ', response);
        setData(response);
      } catch (error) {
        console.error('Error fetching produits:', error);
      }
    };
    fetchFournisseurs();
  }, []);

  const table = useAdvanceTable({
    data: data,
    columns: columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 90000,
    selectionColumnWidth: 52
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Card>
          <Card.Header className="px-0">
            <TableHeader
            // handleShow={handleShow}
            // handleDetailsUpdate={handleDetailsUpdate}
            // setTypeLignes={setTypeLignes}
            />
          </Card.Header>
          <Card.Body
            className="p-0"
            style={{ height: '500px', overflowY: 'auto' }}
          >
            <AdvanceTable
              headerClassName="bg-body-tertiary align-middle"
              rowClassName="btn-reveal-trigger align-middle"
              tableProps={{
                size: 'sm',
                className: 'fs-10 mb-0 overflow-hidden'
              }}
              // onRowClick={row => handleLignes(row)}
              fixedHeader={true}
            />
          </Card.Body>
          <Card.Footer>
            <AdvanceTableFooter rowInfo />
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
    </>
  );
};

export default ProduitsTable;
